import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/remote-config';

const config = {
  apiKey: 'AIzaSyARPxllSeQeJ0D75NNTl68NigYdvemOkFE',
  authDomain: 'leap-81741.firebaseapp.com',
  databaseURL: 'https://leap-81741.firebaseio.com',
  projectId: 'leap-81741',
  storageBucket: 'leap-81741.appspot.com',
  messagingSenderId: '373211067678',
  appId: '1:373211067678:web:2db7e3255d819b9d5fc50f',
  measurementId: 'G-4DQT3H3E9J',
};

const firebaseApp = !firebase.apps.length ? firebase.initializeApp(config) : firebase.app();

export { firebaseApp };
